import { SetProfileInfo } from './IdentityActions';

export {
    SetProfileInfo
};


// WEBPACK FOOTER //
// ./src/actions/ActionsIndex.tsx